var _defs, _g, _tspan, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadnow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 141.882,
    height: 39,
    viewBox: "0 0 141.882 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_10",
    x: 0,
    y: 0,
    width: 141.882,
    height: 39,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2457c5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(-1019 -178)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1019, 178)",
    filter: "url(#Rectangle_10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10-2",
    "data-name": "Rectangle 10",
    width: 135.882,
    height: 33,
    rx: 10,
    transform: "translate(3)",
    fill: "#4067f1"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Upload_Now",
    "data-name": "Upload Now",
    transform: "translate(1061.882 199)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Arial-Regular",
    style: {
      fontFamily: "Arial"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Upload Now"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-file-upload",
    "data-name": "Icon material-file-upload",
    d: "M10.324,13.676h4.235V9.441h2.824L12.441,4.5,7.5,9.441h2.824ZM7.5,15.088h9.882V16.5H7.5Z",
    transform: "translate(1034.5 184.5)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadnow);
export default __webpack_public_path__ + "static/media/uploadnow.ad7862c3fcc4128750946a6b8ea90bb9.svg";
export { ForwardRef as ReactComponent };